import { useEffect, useRef } from "react";

/**
 * exp: unix timestamp (saniye)
 * warningBeforeMs: token bitmeden kaç ms önce uyarı verilecek
 * onWarning: uyarı zamanı gelince çalışır
 * onExpire: token bittiği anda çalışır (kesin logout için)
 */
export function useSessionTimers(exp, warningBeforeMs, onWarning, onExpire) {
  const warningTimer = useRef(null);
  const expireTimer = useRef(null);

  useEffect(() => {
    if (!exp) return;

    const expiresAtMs = exp * 1000;
    const now = Date.now();

    const warningAtMs = expiresAtMs - warningBeforeMs;

    const warningDelay = warningAtMs - now;
    const expireDelay = expiresAtMs - now;

    if (warningTimer.current) clearTimeout(warningTimer.current);
    if (expireTimer.current) clearTimeout(expireTimer.current);

    if (warningDelay <= 0) {
      onWarning?.();
    } else {
      warningTimer.current = setTimeout(() => onWarning?.(), warningDelay);
    }

    if (expireDelay <= 0) {
      onExpire?.();
    } else {
      expireTimer.current = setTimeout(() => onExpire?.(), expireDelay);
    }

    return () => {
      if (warningTimer.current) clearTimeout(warningTimer.current);
      if (expireTimer.current) clearTimeout(expireTimer.current);
    };
  }, [exp, warningBeforeMs, onWarning, onExpire]);
}
